import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';

@Component({
  selector: 'wizard-add-user',
  templateUrl: './add.user.fusion.html',
  styleUrls: ['../wizard.user.style.scss']
})
export class AddUserFusionComponent implements IWizardContentComponent, OnInit {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() step: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() subStep: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any;
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;

  @ViewChild('currentForm') form: NgForm;

  username: string;
  name: string;
  surname: string;
  email: string;
  password: string;
  confirmPassword: string;

  ngOnInit() {
    this.step.form = this.form;
  }

  userNameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'userNameInput',
      key: 'username',
      newValue: this.username,
      isValid: this.form.controls.username.valid
    });
  }

  nameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'nameInput',
      key: 'name',
      newValue: this.name,
      isValid: this.form.controls.name.valid
    });
  }

  surNameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'surNameInput',
      key: 'surname',
      newValue: this.surname,
      isValid: this.form.controls.surname.valid
    });
  }

  emailUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'emailInput',
      key: 'email',
      newValue: this.email,
      isValid: this.form.controls.email.valid
    });
  }

  passwordUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'passwordInput',
      key: 'password',
      newValue: this.password,
      isValid: this.form.controls.password.valid
    });
  }

  confirmPasswordUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'passwordConfirmInput',
      key: 'confirmPassword',
      newValue: this.confirmPassword,
      isValid: this.form.controls.confirmPassword.valid
    });
  }

  isLoading(): boolean {
    return this.wizardCtrl.getWizardService().isLoading;
  }
}
